import React from "react";
import qs from "qs";
import { NuTab, NuTabs } from "../NuTab";
import Overview from "../Overview";
import DataCollection from "../DataCollection";
import DataAnnotation from "../DataAnnotation";
import DataFormat from "../DataFormat";
import Lidarseg from "../Lidarseg";
import Tutorial from "../Tutorial";
import Explore from "../Explore";
import DownloadNuScenes from "../Download/nuScenesDownload";
import history from "../../utils/history";
import _ from "lodash";
import styles from "./nuScenes.module.scss";
import unsortedOptions from "../../constants/scenes.json";
import { useLocation } from "react-router-dom";
import lidarSeg from "../../assets/images/lidarseg.jpg";
import lidarSegText from "../../assets/images/nuScenes-lidarseg-text.png";
import Meta from "../../partials/meta";
import motionalLogoSmall from "../../assets/images/motional-logo-2.png";

const options = _.sortBy(unsortedOptions, "name");

function NuScenes(): JSX.Element {
  const { search } = useLocation();
  const [curTabValue, setCurTabValue] = React.useState(0);
  const handleChange = (event: unknown, newValue: number): void => {
    history.push("/nuscenes");
    setCurTabValue(newValue);
  };

  const {
    tutorial,
    sceneId = options[0].name,
    frame,
    view = "lidar",
  } = qs.parse(search, {
    ignoreQueryPrefix: true,
  });
  const handleTutorialChange = (value: string) => {
    history.push(`?tutorial=${value}`);
  };

  const handleSceneChange = (value: string) => {
    history.push(`?sceneId=${value}&frame=${frame || 0}&view=${view}`);
  };

  const handleViewChange = (value: string) => {
    history.push(`?sceneId=${sceneId}&frame=${frame || 0}&view=${value}`);
  };

  return (
    <div className={styles.nuscenes}>
      <Meta
        title="nuScenes"
        description="The nuScenes dataset (pronounced /nuːsiːnz/) is a public large-scale dataset for autonomous driving developed by Motional (formerly nuTonomy). By releasing a subset of our data to the public, Motional aims to support public research into computer vision and autonomous driving."
      />
      <div className={styles.logo}>
        <img src={lidarSeg} alt="" className={styles.logoImg} />
        <img src={lidarSegText} alt="" className={styles.logoText} />
      </div>
      <div className="pb-2em text-justify">
        <h1 id="nuscenes" className={styles.h1}>
          <img src={motionalLogoSmall} alt="Motional logo" />
          nuScenes
        </h1>
        <div className={`content ${styles.tabs}`}>
          <NuTabs
            value={curTabValue}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            <NuTab label="Overview" hash="overview" />
            <NuTab label="Data collection" hash="data-collection" />
            <NuTab label="Data format" hash="data-format" />
            <NuTab label="Data annotation" hash="data-annotation" />
            <NuTab label="Tutorials" hash="tutorials" />
            <NuTab label="Explore" hash="explore" />
            <NuTab label="Panoptic" hash="panoptic" />
            <NuTab label="Downloads" hash="download" />
            <NuTab label="Code" hash="code" />
          </NuTabs>
        </div>
        <h2 id="overview" className={styles.h2}>
          Overview
        </h2>
        <Overview />
        <h2 id="data-collection" className={styles.h2}>
          Data Collection
        </h2>
        <DataCollection />
        <h2 id="data-format" className={styles.h2}>
          Data format
        </h2>
        <DataFormat />
        <h2 id="data-annotation" className={styles.h2}>
          Data annotation
        </h2>
        <DataAnnotation />
        <h2 id="tutorials" className={styles.h2}>
          Tutorials
        </h2>
        <Tutorial slug={tutorial} onTutorialChange={handleTutorialChange} />
        <h2 id="explore" className={styles.h2}>
          Explore
        </h2>
        <Explore
          sceneId={sceneId}
          frame={frame}
          view={view}
          onSceneChange={handleSceneChange}
          onViewChange={handleViewChange}
        />
        <h2 id="panoptic" className={styles.h2}>
          Panoptic
        </h2>
        <Lidarseg />
        <h2 id="download" className={styles.h2}>
          <img src={motionalLogoSmall} alt="Motional logo" />
          Downloads
        </h2>
        <DownloadNuScenes />
        <h2 id="code" className={styles.h2}>
          Code
        </h2>
        <section className="content pb-2em text-justify">
          <p>
            The devkit for the nuScenes dataset can be found&nbsp;
            <a
              href="https://github.com/nutonomy/nuscenes-devkit"
              target="_blank"
              rel="noreferrer"
            >
              here on our GitHub repo
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}
export default NuScenes;
